var lx = lx || {};
lx.payment = lx.payment || {};

lx.payment = {
    orderSummary: function (pSeat, pSub, pSto) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=Stripe_OrderSummary",
                x01: pSeat,
                x02: pSub,
                x03: pSto
            },
            success: function (d) {
                $('#uiCharge').html(d);
            }
        });
    }, 
	WebshopPaymentIntent: function () {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=Stripe_Webshop_Checkout" 
            },
            success: function (d) {
                $('#uiCard').html(d);
            }
        });		
	}
};


lx.payment.product = {
	cancel: function cancelSubscription (pSubscId) {
			apex.server.process("CANCEL_SUBSCRIPTION", {
				x01: pSubscId
			}, {
				success: function(pData) {
					apex.message.showPageSuccess("Subscription Cancelled Successfully!");
					apex.region("SubscriptionID").refresh();
				},
				error: function(request, status, error) {
					console.error("AJAX Error:", error);
				}
			});
		}
}

